import { useEffect, useState } from 'react'
import { api } from '../api'
import { useSession } from '../../ui/Session'
import { nativeName, offered } from './customer'
import type { LanguageCode } from './languages'

/**
 * The customer languages of the organisation being edited: the person's own, or
 * for the installation owner the one chosen in the top bar (or named here).
 */
export function useCustomerLanguages(organisation?: string): LanguageCode[] {
  const session = useSession()
  const identity = session?.identity
  const member = Boolean(identity?.staff.tenantId)
  const named = organisation || (!member ? session?.org?.organisation : '') || ''
  const [read, setRead] = useState<{ org: string; list: LanguageCode[] } | null>(null)

  useEffect(() => {
    if (!named || member) return
    let live = true
    api
      .orgLanguages(named)
      .then((v) => live && setRead({ org: named, list: v.customer }))
      .catch(() => live && setRead(null))
    return () => {
      live = false
    }
  }, [named, member])

  if (!member && named && read?.org === named) return offered(read.list)
  return offered(identity?.languages?.customer)
}

/** The customer languages as [code, native name] pairs, for a row of inputs. */
export function useTextLanguages(organisation?: string): Array<[string, string]> {
  return useCustomerLanguages(organisation).map((c) => [c, nativeName(c)])
}
